'use client';

import { approveProposalService, rejectProposalService } from '@musinsa/services-curator';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

export const useApproveProposal = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: approveProposalService,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: curatorQueries.campaigns.proposalDetail._def,
      });
      queryClient.invalidateQueries({
        queryKey: curatorQueries.campaigns.proposals._def,
      });
    },
  });
};

export const useRejectProposal = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: rejectProposalService,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: curatorQueries.campaigns.proposalDetail._def,
      });
      queryClient.invalidateQueries({
        queryKey: curatorQueries.campaigns.proposals._def,
      });
    },
  });
};
